import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { deleteSubuser, extraUsersList, getSuperAdminUsers } from './async';
import { initialState } from './users';

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(extraUsersList.fulfilled, (s, { payload: { users, usersByDate } }) => {
                    s.users = users;
                    s.usersByDate = usersByDate;
                    s.isUsersLoaded = true;
                })
                .addCase(getSuperAdminUsers.fulfilled, (state, { payload: { users } }) => {
                    state.superAdminUsers = users.map(
                        (item: {
                            ID: number;
                            NAME: string;
                            EMAIL: string;
                            PARENT_ID: number;
                            TYPE: number;
                            STATUS: number;
                            TIMEZONE: string;
                            directLoginLink: string;
                        }) => ({
                            id: item.ID,
                            name: item.NAME,
                            email: item.EMAIL,
                            parentId: item.PARENT_ID,
                            type: item.TYPE,
                            status: item.STATUS,
                            timezone: item.TIMEZONE,
                            directLoginLink: item.directLoginLink,
                        }),
                    );
                })
                .addCase(deleteSubuser.fulfilled, (s, { meta: { arg } }) => {
                    s.users = s.users.filter((user) => user.id !== arg.subuser);
                    s.usersByDate = s.usersByDate.filter((user) => user.id !== arg.subuser);
                }),
        ),
});
